import type { FloorPlanViewBox } from './floorPlanMath';

export function planPointToSheetPercent(
  x: number,
  y: number,
  viewBox: FloorPlanViewBox,
): { left: number; top: number } {
  return {
    left: ((x - viewBox.x) / Math.max(viewBox.w, 1)) * 100,
    top: ((y - viewBox.y) / Math.max(viewBox.h, 1)) * 100,
  };
}
